import Button from './button';
import './style/index';
export default Button;